import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "price",
    standalone: true,
})
export class SyndicatePricePipe implements PipeTransform {
  transform(value: string, amount: string): string {
    if (!value || !amount) {
      return value;
    }
    value = value.replace("[offer_price]", amount);
    return value;
  }
}
